import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import Onefire1 from '../assets/images/alterb.png'
import Onefire2 from '../assets/images/bitcoin.png'
import Onefire3 from '../assets/images/etherem.png'
import Onefire4 from '../assets/images/incanto.png'
import Onefire5 from '../assets/images/ripple.png'
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';


// import required modules
import { Navigation, Autoplay } from 'swiper/modules';


export default function Trusted() {
  const swiperRef = useRef<any>(null); // Create a ref for the swiper instance

  return (
    <>
      <div className="row">
        <div className="col-12">
          <Swiper
            ref={swiperRef}
            modules={[Autoplay]}
            autoplay={true}
            loop={true}
            speed={10000}
            slidesPerView={5}
            spaceBetween={2}
            breakpoints={{
              768: {
                slidesPerView: 2,  
              },
              1024: {
                slidesPerView: 8, 
                spaceBetween:16
              },
            }}
          >
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire5} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire2} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire1} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire4} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire5} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire2} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire1} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire5} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='Trusted'>
                <img src={Onefire1} alt="cricket" className='img-fluid' />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  );
}
